import { format } from 'date-fns';

const datedFilename = (prefix: string, date: Date) => {
  const dateStr = format(date ?? new Date(), 'dd-MM-yyyy');
  const randomNum = Math.floor(Math.random() * 100000000);
  const randomStr = String(randomNum).padStart(8, '0');
  const fileName = `${prefix}-${dateStr}-${randomStr}.xlsx`;
  return fileName;
};

export default datedFilename;
